import { render, staticRenderFns } from "./MembershipRequest.vue?vue&type=template&id=c3d8c216&"
import script from "./MembershipRequest.vue?vue&type=script&lang=js&"
export * from "./MembershipRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports